import { LoopScrollSwipper } from '@/component/ScrollSwipper';
import { logger } from '@/common/log';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { Box, Space } from '@kibt/meta-ui-krn';
import React, { useEffect, useMemo } from 'react';
import { Text, StyleSheet, View } from 'react-native';
import { scaleW } from '@/common/style';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';

const styles = StyleSheet.create({"tagWrap":{"overflow":"hidden","borderRadius":"0.9661835748792271rem","marginRight":"1.9323671497584543rem","marginBottom":"1.9323671497584543rem","height":"5.797101449275363rem","paddingHorizontal":"2.8985507246376816rem","alignItems":"center","justifyContent":"center"},"detailTagWrap":{"backgroundColor":"#FFF6F3"},"commentTagWrap":{"backgroundColor":"#F2F2F2","borderWidth":"0.12077294685990339rem","borderColor":"#F2F2F2"},"commentImageTagWrap":{"backgroundColor":"#FFF6F3","height":"4.347826086956522rem"},"selectTagWrap":{"backgroundColor":"rgba(255, 73, 6, 0.12)","borderWidth":"0.12077294685990339rem","borderColor":"#FF4906"},"unselectTag":{"color":"rgba(0, 0, 0, 0.64)"},"selectTag":{"color":"rgba(255, 73, 6, 1)"}});

const emptyFunction = () => {
    // 空函数体
};

const SelectTag = props => {
    const { tagList, value = '', onChange = emptyFunction, disabled = false, from = 'detail' } = props;

    const onTagShow = tag => {
        logger.sendShow({
            action: 'REVIEWS_SORT_TAG',
            params: {
                content: tag?.value ?? '',
            },
        });
    };

    const content = useMemo(() => {
        // 单选可取消
        const toggleTag = tag => {
            const v = value === tag ? '' : tag;
            onChange(v);
            if (v) {
                logger.sendClick({
                    action: 'REVIEWS_SORT_TAG',
                    params: {
                        content: v,
                    },
                });
            }
        };

        const tagStyleMap = {
            detail: styles.detailTagWrap,
            commentImage: styles.commentImageTagWrap,
            default: styles.commentTagWrap,
        };
        return tagList
            ?.filter(i => i)
            ?.map(tag => (
                <KTouchableOpacity disabled={disabled} key={tag} onPress={() => toggleTag(tag.value)}>
                    <ViewVisible onVisible={() => onTagShow(tag)}>
                        <Space gap={12}>
                            <Box>
                                <View
                                    style={[
                                        styles.tagWrap,
                                        tagStyleMap[from] || tagStyleMap.default,
                                        value === tag.value ? styles.selectTagWrap : {},
                                    ]}>
                                    <Text
                                        style={[
                                            value === tag.value ? styles.selectTag : styles.unselectTag,
                                            { fontSize: from === 'commentImage' ? scaleW(11) : scaleW(14) },
                                        ]}>{`${tag?.value}(${tag?.displayAmount})`}</Text>
                                </View>
                            </Box>
                        </Space>
                    </ViewVisible>
                </KTouchableOpacity>
            ));
    }, [disabled, from, onChange, tagList, value]);

    const tags = useMemo(
        () =>
            from === 'detail' ? (
                <LoopScrollSwipper>
                    <View style={{"flexDirection":"row"}}>{content}</View>
                </LoopScrollSwipper>
            ) : (
                <View style={{"flexDirection":"row","flexWrap":"wrap"}}>{content}</View>
            ),
        [content, from]
    );

    return tags;
};

export default SelectTag;
